// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { scheduleReminderModalStyles } from "@insite/content-library/Components/ScheduleReminderModal";
import { GridOffset } from "@insite/mobius/GridContainer";
import { xScreen } from "@conklin/XDL/Utilities";
import { modalButtonsActionStyles } from "@conklin/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = {
    sizeVariant: "medium",
};

scheduleReminderModalStyles.titleText = {
    variant: "h3",
    size: 20,
    weight: 700,
    css: css`
        &&& {
            margin-bottom: 0;
        }
    `,
};

scheduleReminderModalStyles.hintText = {
    size: 15,
    css: css`
        margin-top: 5px;
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = scheduleReminderModalStyles.startDatePicker;

scheduleReminderModalStyles.middleRowLeftColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.middleRowRightColumnGridItem = {
    width: 12,
};

scheduleReminderModalStyles.frequencyRadioGroup = {
    horizontal: true,
};

scheduleReminderModalStyles.weeklyRadio = {};

scheduleReminderModalStyles.monthlyRadio = {};

scheduleReminderModalStyles.bottomRowGridItem = {
    width: 12,
};

scheduleReminderModalStyles.buttonsContainer = {
    gap: 0,
    css: css`
        & ${GridOffset} {
            flex-wrap: wrap;
            justify-content: space-between;
        }
    `,
};

scheduleReminderModalStyles.stopButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        order: 2;
        &&& {
            margin-left: 10px;
            ${xScreen("lte", "xs")} {
                width: 100%;
                margin-left: 0;
                margin-bottom: 10px;
                order: -1;
            }
        }
    `,
};

scheduleReminderModalStyles.cancelButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        &&& {
            margin-right: 10px;
        }
        ${xScreen("lte", "xs")} {
            &&& {
                order: 1;
                width: 100%;
                margin-right: 0;
                margin-top: 10px;
            }
        }
    `,
};

scheduleReminderModalStyles.scheduleButtonGridItem = {
    css: css`
        flex-basis: auto;
        max-width: unset;
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

scheduleReminderModalStyles.cancelButtonsGridItem = modalButtonsActionStyles.buttonsGridItem;

scheduleReminderModalStyles.dismissCancelButton = modalButtonsActionStyles.cancelButton;

scheduleReminderModalStyles.confirmCancelButton = modalButtonsActionStyles.submitButton;
